import Vue from 'vue'
import Vuex from 'vuex'
import Router from '@/router'
import storeChat from '@/components/chat/store'
import { stat } from 'fs';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // thông tin user
        user:{
            id:0,
            login:'',
            fullname:'',
            avatar: '',
            create_at:'',
            is_payment:0,
            payment_expires:'',
            avatar:'',
            phone:'',
            admin_id:''
        },
        notifi: {}, /** thông tin notifi */
        token:'', // token gọi api của user
        logged: false, // trạng thái login
        staff:{}, // thông tin các nhân viên trong cùng tài khoản
        guest_id: 0, // id khách hàng đang mở chat
        rawChat:{}, // nhận các sự kiện chat
        rawSupplier:{}, // nhận các sự kiện khách truy cập website
        rawNoti:{}, // các sự kiện khác (chuyển chat, banned, close chat, like, unline, vvv)
        count:{
            message:0, // tổng số message đang chờ
            visitor:0 // tổng số visit mới đang vào
        },
        show_alert_success: false, /** hiển thị thông báo lỗi */
        show_alert_error: false,
        alert_msg_success: '', /** tin nhắn thành công */
        alert_msg_error: '', /** tin nhắn lỗi */
        store_quickanswer: [], /** nơi lữu trữ  các cài đặt quick answer */
        /** phần cài đặt khung chat */
        boxchat: {
            online: {
                bar: {val : ''},
                greeting_chat: {val: ''} 
            },
            offline: {
                bar: {val: ''},
                greeting_chat: {val: ''},
                button: {val:'Gửi tin nhắn'}
            },
            offline_field:{
                name: {val: '', require: 1, using: 1, type: 'text'},
                phone: {val: '', require: 1, using: 1, type: 'text'},
                email: {val: '', require: 0, using: 0, type: 'text'},
                message: {val: '', require: 1, using: 1, type: 'texteare'}
            },
            contact: {
                greet:{val:'Vui lòng cho chúng tôi biết thông tin để có thể liên hệ với bạn nhanh nhất'},
                field:{
                    name: {title: '', val: 'Tên của bạn',  require: 1, using: 1, type: 'text'},
                    phone: {title: '', val: 'Số ĐT',  require: 1, using: 1, type: 'text'},
                    email: {title: '', val: 'Email',  require: 1, using: 1, type: 'text'},
                    address: {title: '', val: 'Email',  require: 1, using: 1, type: 'text'}
                }
            },
            termssheet:{
                val: 0,
                greet: 'Vui lòng đọc qua các chính sách của chúng tôi trước khi bắt đầu cuộc chat',
                policy_text: 'Chính sách bảo hành sản phẩm',
                policy_url: 'http://vchat.vn',
                check_text: 'Tôi đã đọc và đồng ý với các điều khoản trên'
            }
        },
        boxchat_status: '', // box preview đang là box minisize hay là maxsize
        accept_chat: true, // trạng thái có nhận chat hay không
        permission: {}, /** mảng phân quyền theo từng gói */
        package: 0, /** gói đang dùng là gói nào */
        chat_limited: {
            status: false, /** trạng thái giới hạn 50 cuộc chat,= true: là không được chat */
            error: ''  /** thông báo lỗi vượt quá giới hạn số cuộc chat */
        },
        default_permission: {}, /** mảng phân quyền của tk */
        user_permission: {}, /** quyền của user trong admin */

    },
    mutations: {

        // this.$store.commit(mutation function, data)
        // function sẽ cập nhật thông tin vào state
        /**
         * 
         * @param {*} state 
         * @param {*} data {
         *  token: 
         *  user:
         * }
         * 
         */
        setLogin(state, response){
            if(response != null){
                let data = response.data
                let code = response.code
                let token = response.token
                let error = response.error
                if(code == 200){
                    state.logged = true // set đăng nhập
                    // lưu thông tin vào localstorage và redirect về trang chat
                    let ls = localStorage
                    ls.setItem('vchat_user', JSON.stringify(data));

                    // phân tích dữ liệu data để gắn vào state
                    state.user  = data
                    state.token = token
                    ls.setItem('token', token)

                    // chuyển đến trang dashboad
                    Router.push({name: 'index'})
                    window.location.reload()
                    

                } // end check code == 200
                
            }
        },

        /**
         * set logout
         */
        setLogout(state, value){
            let ls = localStorage
            ls.removeItem('token')
            ls.removeItem('vchat_user')
            state.logged = false
            Router.push({name: 'login'})
        },

        /**
         * Action sẽ gọi lên mutation khi có sự thay đổi (có tin nhắn chat hoặc sự kiện chat)
         * thì set_rawchat sẽ cập nhật lại biến state.rawchat
         * @param {*} state 
         * @param {*} data 
         */
        set_rawchat(state, data){
            state.rawChat = data
        },

        set_rawsupplier(state, data){
            state.rawSupplier = data
        },

        set_rawnoti(state, data){
            state.rawNoti = data
        },
        
        /** gắn lại thông tin user khi vào trang app.vue */
        set_user(state, data){
            state.user = data
            let ls = localStorage
            ls.setItem('vchat_user', JSON.stringify(data));
        },

        /** cập nhật lại notifi */
        set_notifi(state, data){
            state.notifi = data
            /** cập nhật lại vào localstorage */
            if(window.localStorage){
                localStorage.setItem('notifi', JSON.stringify(data))
            }
        },

        /** set id khách hàng đang mở cuộc chat: trong component chat/index.vue */
        set_guestid(state, data){
            state.guest_id = data
        },
        /** set count message */
        set_notifychat(state, data){
            state.count.message = data
        },
        /** set show alert success */
        set_alert_msg_success(state, data){
            state.alert_msg_success = data
            state.show_alert_success = true
            setTimeout(function(){
                state.show_alert_success = false
                state.alert_msg_success = ''
            }, 5000)
        },
        set_alert_msg_error(state, data){
            state.alert_msg_error = data
            state.show_alert_error = true
            setTimeout(function(){
                state.show_alert_error = false
                state.alert_msg_error = ''
            }, 5000)
        },

        /** cập nhật quick anser store */
        set_store_quickanswer(state, data){
            state.store_quickanswer = data
        },

        
        /** set cài đặt của boxchat */
        set_boxchat_online(state, data){
            state.boxchat.online = data
        },
        /** set cài đặt của boxchat */
        set_boxchat_offline(state, data){
            state.boxchat.offline = data
        },
        /** set cài đặt của boxchat */
        set_boxchat_offline_field(state, data){
            state.boxchat.offline_field = data
        },
        /** set cài đặt của contact form */
        set_boxchat_contact(state, data){
            state.boxchat.contact = data
        },
        /** set cài đặt của contact form */
        set_boxchat_termssheet(state, data){
            state.boxchat.termssheet = data
        },

        /** lấy trạng thái box preview đang là box minisize hay maxsize */
        set_boxchat_status(state, data){
            state.boxchat_status = data
        },

        /** set trạng thái nhận chat hay không */
        set_status_accept_chat(state, data){
            state.accept_chat = data
        },

        /** lưu permisstion */
        set_permission(state, data){
            state.permission  = data
        },

        set_package(state, data){
            state.package = data
        },

        /** set trạng thái chat limited */
        set_chat_limited(state, data){
            state.chat_limited = Object.assign({}, data)
        },

        /** set default quyền khi App.vue được load */
        set_default_permission(state,data){
            state.default_permission = Object.assign({}, data)
        },

        /** set quyền cho user khi App.vue được load */
        set_user_permission(state, data){
            state.user_permission = Object.assign({}, data)
        }
    },
    getters: {
        
        /**
         * 
         * getter sẽ láy lấy ra các biến của state
         */

        rawchat(state){
            return state.rawChat
        },

        rawsupplier(state){
            return state.rawSupplier
        },

        rawnoti(state){
            return state.rawNoti
        },

        /** trả ra id khách hàng đang mở boxchat */
        guest_id(state){
            return state.guest_id
        },

        /** trả ra thông tin user */
        getUser(state){
            return state.user
        },

        /** lấy thông tin notifi */
        getNotifi(state){
            return state.notifi
        },

        /** get count message */
        get_notifychat(state){
            return state.count.message
        },
        /** get count visitor */
        getcountvisitor(state){
            return state.count.visitor
        },
        get_alert_msg_error(state){
            return state.alert_msg_error
        },
        get_alert_msg_success(state){
            return state.alert_msg_success
        },
        get_show_alert_error(state){
            return state.show_alert_error
        },
        get_show_alert_success(state){
            return state.show_alert_success
        },
        get_store_quickanswer(state){
            return state.store_quickanswer
        },

        get_boxchat_online(state){
            return state.boxchat.online
        },
        get_boxchat_offline(state){
            return state.boxchat.offline
        },
        get_boxchat_offline_field(state){
            return state.boxchat.offline_field
        },
        get_boxchat_contact(state){
            return state.boxchat.contact
        },
        get_boxchat_termssheet(state){
            return state.boxchat.termssheet
        },

        /** get trạng thái box preview đang là box minisize hay là maxzi */
        get_boxchat_status(state){
            return state.boxchat_status
        },

        /** lấy ra trạng thái có nhận chat hay không */
        get_status_accept_chat(state){
            return state.accept_chat
        },

        /** lấy permission theo từng gói */
        get_permission(state){
            return state.permission
        },

        /** lấy thong tin gói */
        get_package(state){
            return state.package
        },

        /** lấy trạng thái chat limited */
        get_chat_limited(state){
            return state.chat_limited
        },

        /** lấy quyền mặc định để admin set cho user */
        get_default_permission(state){
            return state.default_permission
        },

        /** get quyền của nhân viên */
        get_user_permission(state){
            return state.user_permission
        }



    },
    actions: {
        /**
         * 
         * Function trong action đẻ các component gọi theo kiểu
         * ...mapaction()
         * hàm trong này sẽ gọi lên mutation bằng hàm commit
         * dùng ...mapaction() để trong component có thể gọi theo kiểu this.function_name() giống như action này là methode của component
         */

        set_visitor_id({commit}, value){
            commit('set_visitor_id', value)
        },

        set_loged({commit}, value){
            commit('setLoged', value)
        }
    },
    modules: {
        storeChat
    }
})

export default store